var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle-button',{attrs:{"icon":"mdi-printer","color":"primary","small":_vm.small,"tooltip":_vm.$t('print')},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }